// just for test mocking
export const getHostname = () => window.location.hostname;
export const getMaybeAppName = () => {
  var _window;
  return (_window = window) === null || _window === void 0 || (_window = _window.hubspot) === null || _window === void 0 || (_window = _window.bender) === null || _window === void 0 ? void 0 : _window.currentProject;
};
export const getWindow = () => window;